import React from 'react';
import { Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

const BackButton = ({ history, title, t }) => {
	return <Button onClick={history.goBack} className='btn btn-back btn-block-xxs'><FontAwesome name='arrow-circle-left' /> {title || t('Common_Back')}</Button>;
};

export default withTranslation()(withRouter(BackButton));